/**
 * To use this, define $scope.someCallbackFunction = function (newVal) { ... } to be called when the value changes
 *
 * <input type="text" on-change-commit="someCallbackFunction" ng-model="someVal" />
 */
export default function OnChangeCommitDirective() {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      onChangeCommit: '=?'
    },
    require: '?ngModel',
    replace: false,
    link: function (scope, elem, attrs, ngModel) {
      // No need to error if ng-model is not set, but we can't do anything if not, so return
      if (!ngModel) {
        return false;
      }

      // Save the initial value so that we only call the change callback if this value changes
      var onFocusValue;

      elem.on('focus', function () {
        onFocusValue = ngModel.$modelValue;
      });

      elem.on('blur', function () {
        if (ngModel.$modelValue != onFocusValue) {
          if (scope.onChangeCommit) {
            scope.onChangeCommit(ngModel.$modelValue);
          }
        } else {
          // no change, do nothing
        }
      });
    }
  };
}
